import { useState } from 'react';
import { Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IProcedureOptionProps {
  label: string;
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: () => void;
  testId?: string;
}

export const ProcedureOption = ({
  label,
  isSelected,
  isDisabled,
  onToggle,
  testId,
}: IProcedureOptionProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const showHoverBorder = isHovered && !isSelected && !isDisabled;

  const handleClick = () => {
    if (!isDisabled) {
      onToggle();
    }
  };

  const getBorderColor = () => {
    if (isSelected || showHoverBorder) return Colors.secondary_500;
    return Colors.neutral_100;
  };

  const getTextColor = () => {
    if (isDisabled) return Colors.neutral_300;
    return Colors.neutral_600;
  };

  return (
    <Row
      data-testid={testId}
      data-cy={testId}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-pressed={isSelected}
      aria-disabled={isDisabled}
      alignItems="center"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
          e.preventDefault();
          onToggle();
        }
      }}
      style={{
        width: 325,
        borderRadius: 24,
        padding: '6.75px 20px',
        backgroundColor: isSelected ? Colors.primary_50 : Colors.white,
        border: `1.5px solid ${getBorderColor()}`,
        cursor: isDisabled ? 'default' : 'pointer',
        transition: 'border-color 0.15s, background-color 0.15s',
      }}
    >
      <Text fontSize={16} style={{ color: getTextColor() }}>
        {label}
      </Text>
    </Row>
  );
};
